import React, { useEffect, useState } from 'react';
import { winnreAuth } from '../utils/axios';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { authActions } from '../store/auth-slice';

function useBookingSummary() {
    const [userAccountSummary, setUserAccountSummary] = useState(null);
    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
    const user = useSelector((state) => state.auth.user);
    const dispatch = useDispatch();
    useEffect(() => {
        if (isAuthenticated && user?.status === 'REGISTERED') {
            getUserAccountSummary();
        }
    }, [isAuthenticated]);

    const getUserAccountSummary = () => {
        if (isAuthenticated && user?.status === 'REGISTERED') {
            winnreAuth({
                method: 'get',
                url: '/winnre/user/booking/account-summary'
            })
                .then((res) => {
                    // console.log('CALL 2');

                    // console.log('SUMMARY', res);
                    setUserAccountSummary(res);
                    dispatch(
                        authActions.setRewardPoints(
                            res?.rewardPoints + res?.unInvoicedCommission
                        )
                    );
                    dispatch(
                        authActions.setReloyRewardPoints(res?.reloyRewardPoints)
                    );
                })
                .catch((e) => {
                    setUserAccountSummary(null);
                });
        }
    };

    return { userAccountSummary, getUserAccountSummary };
}

export default useBookingSummary;
